export default __webpack_public_path__ + "static/media/pelagiad-webfont.2b52d1ee.ttf";